export enum CloseTemplateBasis {
    ACCRUAL = "accrual",
    MODIFIED_CASH_LEDGER = "modified_cash_ledger",
}
